export * from './productDetails';
